const user = (state = {}, data) => {
    switch (data.type) {
        case 'SET_AUTHENTICATION_FLAG':
            return {
                ...state,
                isLogged: data.value,
            };
        case 'SET_VAT_PRICE':
            return {
                ...state,
                excludeVAT: data.value,
            };
        case 'SET_PROFILE_DATA':
            return {
                ...state,
                profile: data.value,
            };
        default:
            return state;
    }
};

export default user;
